import axios from 'axios'
import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export function getProductList(data) {
  return request({ url: '/admin/product/list', method: 'post', data })
}

export function getProductDetail(data) {
  return request({ url: '/admin/product/detail', method: 'post', data })
}

export function createProduct(data) {
  return request({ url: '/admin/product/create', method: 'post', data })
}

export function updateProduct(data) {
  return request({ url: '/admin/product/update', method: 'post', data })
}

export function toggleProductStatus(data) {
  return request({ url: '/admin/product/toggleStatus', method: 'post', data })
}

export function uploadProductImage(file) {
  const formData = new FormData()
  formData.append('image', file)
  return axios.post(process.env.VUE_APP_BASE_API + '/admin/product/uploadImage', formData, {
    headers: {
      Authorization: 'Bearer ' + getToken(),
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => {
    if (res.data.code !== 0) {
      throw new Error(res.data.message || '上传失败')
    }
    return res.data
  })
}
